module.exports = __webpack_public_path__ + "static/media/slider-13.6a0b5f00.jpg";